import { render } from "./RenderAboutLogo.component.vue?vue&type=template&id=22dd45f8"
import script from "./RenderAboutLogo.component.vue?vue&type=script&lang=js"
export * from "./RenderAboutLogo.component.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__